import React from 'react';
import { ActivityIcon, AlertTriangleIcon, BabyIcon, CheckCircleIcon, DollarSignIcon, HeartIcon, HomeIcon, PercentIcon, TrendingUpIcon, AlertCircleIcon } from 'lucide-react';
type IconType = 'activity' | 'alert-triangle' | 'baby' | 'check-circle' | 'dollar-sign' | 'heart' | 'home' | 'percent' | 'trending-up' | 'alert-circle';
type ColorType = 'blue' | 'red' | 'green' | 'purple' | 'teal';
interface KPICardProps {
  title: string;
  value: string | number;
  change?: string;
  isPositive?: boolean;
  icon?: IconType;
  color?: ColorType;
}
export const KPICard: React.FC<KPICardProps> = ({
  title,
  value,
  change,
  isPositive = true,
  icon,
  color = 'blue'
}) => {
  const getIcon = () => {
    const iconProps = {
      size: 24,
      className: `text-${getColorClass()}-500`
    };
    switch (icon) {
      case 'activity':
        return <ActivityIcon {...iconProps} data-id="element-182" />;
      case 'alert-triangle':
        return <AlertTriangleIcon {...iconProps} data-id="element-183" />;
      case 'baby':
        return <BabyIcon {...iconProps} data-id="element-184" />;
      case 'check-circle':
        return <CheckCircleIcon {...iconProps} data-id="element-185" />;
      case 'dollar-sign':
        return <DollarSignIcon {...iconProps} data-id="element-186" />;
      case 'heart':
        return <HeartIcon {...iconProps} data-id="element-187" />;
      case 'home':
        return <HomeIcon {...iconProps} data-id="element-188" />;
      case 'percent':
        return <PercentIcon {...iconProps} data-id="element-189" />;
      case 'trending-up':
        return <TrendingUpIcon {...iconProps} data-id="element-190" />;
      case 'alert-circle':
        return <AlertCircleIcon {...iconProps} data-id="element-191" />;
      default:
        return null;
    }
  };
  const getColorClass = () => {
    switch (color) {
      case 'blue':
        return 'blue';
      case 'red':
        return 'red';
      case 'green':
        return 'green';
      case 'purple':
        return 'purple';
      case 'teal':
        return 'teal';
      default:
        return 'blue';
    }
  };
  return <div className="bg-white rounded-lg shadow p-6" data-id="element-192">
      <div className="flex justify-between items-start" data-id="element-193">
        <div data-id="element-194">
          <p className="text-gray-500 text-sm font-medium" data-id="element-195">{title}</p>
          <h3 className="text-2xl font-bold mt-1" data-id="element-196">{value}</h3>
          {change && <div className={`flex items-center mt-2 ${isPositive ? 'text-green-500' : 'text-red-500'}`} data-id="element-197">
              <span className="text-sm font-medium" data-id="element-198">{change}</span>
            </div>}
        </div>
        {icon && <div className={`p-3 rounded-full bg-${getColorClass()}-100`} data-id="element-199">
            {getIcon()}
          </div>}
      </div>
    </div>;
};